{
	"title": "Персонажи",
	"description": "Живой разговор вместо конспекта. Персонаж из IEC Hero объяснит тему по твоим материалам — со ссылками на них.",
	"intro": {
		"title": "Разобрать тему с персонажем",
		"description": "Персонажи живут в IEC Hero. StudyHub подмешивает в разговор фрагменты твоих материалов, чтобы ответы опирались на них, а не на общие знания.",
		"bullets": {
			"materials": "Собеседник отвечает по материалам сессии, а не «вообще».",
			"citations": "Каждое утверждение помечается источником — можно открыть страницу.",
			"hero": "Создание и настройка персонажей остаётся в Hero."
		},
		"readDocument": "Читать документ"
	},
	"blockers": {
		"age_not_confirmed": {
			"title": "Возраст не подтверждён",
			"description": "Этот модуль доступен с {minAge} лет. Возраст определяется по профилю IEC ID — укажите дату рождения в профиле и вернитесь.",
			"action": "Открыть профиль IEC ID"
		},
		"under_minimum": {
			"title": "Пока недоступно",
			"description": "Модуль доступен с {minAge} лет."
		},
		"consent_required": {
			"title": "Нужно согласие на передачу данных",
			"description": "Фрагменты материалов и сообщения уйдут в IEC Hero — стороннему сервису.",
			"action": "Согласен"
		},
		"consent_outdated": {
			"title": "Документ обновился",
			"description": "Условия передачи данных изменились — подтвердите новую версию.",
			"action": "Принять новую версию"
		}
	},
	"actions": {
		"unlink": "Отвязать аккаунт от IEC Hero",
		"menu": "Действия с разделом",
		"unlinkConfirmTitle": "Отвязать аккаунт от IEC Hero?",
		"unlinkConfirmDescription": "StudyHub прекратит передачу фрагментов материалов и сообщений в IEC Hero. Ваши сессии останутся в списке, но вы не сможете их продолжить, пока не свяжете аккаунты снова. Связывание произойдет автоматически при запуске новой сессии.",
		"unlinkConfirm": "Отвязать"
	},
	"unlinked": {
		"title": "Связь с Hero разорвана",
		"description": "Сессии сохранены, но для общения с персонажами необходимо повторно привязать IEC Hero. Запустите любого персонажа ниже — StudyHub восстановит связь с аккаунтом.",
		"relink": "Привязать аккаунт снова",
		"relinked": "Учетные записи повторно связаны — вы можете продолжить работу с персонажами."
	},
	"scenario": {
		"label": "Формат",
		"exam-prep": "Подготовка к экзамену",
		"exam-prepHint": "Короткие вопросы по одному, разбор ошибки сразу после ответа.",
		"socratic": "Сократический диалог",
		"socraticHint": "Собеседник ведёт вопросами и не даёт готовый ответ сразу.",
		"material-explain": "Разбор материала",
		"material-explainHint": "Объяснение по шагам с проверкой, что каждый шаг понятен.",
		"free-kb": "Свободный разговор",
		"free-kbHint": "Ответы на вопросы по материалам сессии, без сценария."
	},
	"catalog": {
		"start": "Начать сессию",
		"starting": "Создаём…",
		"empty": "Подходящих персонажей не нашлось.",
		"stale": "IEC Hero недоступен — показан сохранённый список. Данные могли устареть.",
		"unavailable": "IEC Hero сейчас недоступен. Сессии открываются, новые пока не создать.",
		"emptyFiltered": "По этому запросу никого не нашлось. Измените поиск или снимите фильтры.",
		"loadMore": "Показать ещё",
		"chats": "{count, plural, one {{formatted} диалог} few {{formatted} диалога} many {{formatted} диалогов} other {{formatted} диалога}}",
		"chips": {
			"all": "Все"
		},
		"filters": {
			"tags": "Теги",
			"tagsSelected": "Теги: {count}",
			"sort": "Сортировка"
		},
		"sorts": {
			"popular": "Популярные",
			"new": "Новые",
			"name": "По имени"
		}
	},
	"sessions": {
		"title": "Мои сессии",
		"empty": "Сессий пока нет.",
		"emptyTitle": "Разговоров пока нет",
		"messages": "{count, plural, one {# сообщение} few {# сообщения} other {# сообщений}}",
		"materialsMore": "{name} +{count}",
		"materialsCount": "{count, plural, one {# материал} few {# материала} other {# материалов}}",
		"open": "Открыть",
		"delete": "Удалить",
		"deleted": "Сессия удалена",
		"deleteTitle": "Удалить сессию?",
		"deleteDescription": "Метаданные сессии исчезнут из StudyHub. Сам чат останется в IEC Hero — там он и хранится."
	},
	"chat": {
		"back": "Назад",
		"notFound": "Сессия не найдена.",
		"openInHero": "Открыть в Hero",
		"placeholder": "Спросите о материале…",
		"send": "Отправить",
		"offline": "Сообщения хранятся в IEC Hero — для чтения и ответа нужна сеть.",
		"historyUnavailable": "История не загрузилась: IEC Hero недоступен.",
		"moderated": "Ответ прерван: содержимое не прошло проверку StudyHub.",
		"refunded": "Сообщение не списано — попробуйте ещё раз.",
		"notRefunded": "Ответ начал приходить, поэтому сообщение засчитано.",
		"errors": {
			"generic": "Не получилось получить ответ.",
			"unavailable": "IEC Hero не отвечает.",
			"payment_required": "Лимит на стороне IEC Hero исчерпан.",
			"not_linked": "Связь с аккаунтом Hero потеряна — свяжите его заново.",
			"rate_limited": "Слишком часто. Подождите немного.",
			"network": "Соединение прервалось.",
			"invalid_request": "IEC Hero не удалось обработать это голосовое сообщение. Попробуйте еще раз или отправьте текст."
		},
		"stop": "Остановить",
		"thinking": "Думаю…",
		"greetingLoading": "Персонаж приветствует вас…",
		"voiceRecord": "Записать голосовое сообщение",
		"voiceStop": "Остановить запись",
		"voiceEncoding": "Подготовка голосового сообщения…",
		"voiceMessage": "Голосовое сообщение",
		"voiceFailed": "Не удалось записать голосовое сообщение.",
		"voiceUnsupported": "Запись голоса не поддерживается на этом устройстве.",
		"voicePermissionDenied": "Доступ к микрофону запрещен.",
		"voiceCancel": "Отменить запись",
		"voiceSend": "Отправить голосовое сообщение",
		"voiceRecording": "Запись…",
		"voiceTooShort": "Удерживайте дольше — запись слишком короткая."
	},
	"showcase": {
		"scenarios": {
			"title": "В каком формате разбирать",
			"lead": "Сценарий задаёт, как персонаж ведёт разговор. Его можно поменять перед следующей сессией."
		},
		"characters": {
			"title": "С кем разбирать",
			"lead": "Отобранные персонажи IEC Hero. У каждого свой характер и манера объяснять.",
			"leadTopic": "Отобранные персонажи IEC Hero. Разговор пойдёт по материалам открытой темы."
		},
		"dialogHint": "Выберите формат и собеседника — разговор откроется по текущей теме.",
		"dialogHintCharactersOnly": "Выберите собеседника — диалог начнется по текущей теме.",
		"searchPlaceholder": "Поиск по всему каталогу"
	},
	"launch": {
		"back": "Назад к списку",
		"startingWith": "Начинаем разговор с {name}"
	},
	"tts": {
		"speak": "Озвучить",
		"stop": "Остановить",
		"empty": "Нечего озвучивать",
		"failed": "Не удалось озвучить ответ",
		"quota": "Исчерпан лимит озвучивания текста",
		"mediaTitle": "Ответ персонажа",
		"playbackRate": "Скорость воспроизведения",
		"autoplayOn": "Автоозвучка включена",
		"autoplayOff": "Автоозвучка выкл."
	},
	"about": {
		"title": "О персонаже",
		"noDescription": "Описание пока отсутствует.",
		"oceanTitle": "Личность (OCEAN)",
		"avatarLightbox": "Фотография {name}",
		"ocean": {
			"openness": "Открытость опыту",
			"conscientiousness": "Добросовестность",
			"extraversion": "Экстраверсия",
			"agreeableness": "Доброжелательность",
			"neuroticism": "Невротизм"
		}
	},
	"scope": {
		"chip": {
			"selected": "Контекст: {count, plural, one {# материал} few {# материала} many {# материалов} other {# материала}}",
			"all": "Все материалы"
		},
		"hint": "По умолчанию персонаж отвечает на основе всей вашей библиотеки. Выберите материалы, чтобы ограничить область обсуждения.",
		"dialog": {
			"title": "Материалы для сессии",
			"description": "Персонаж отвечает на основе этих материалов, их фрагменты передаются в IEC Hero. Можно ничего не выбирать — тогда будет доступна вся ваша библиотека."
		}
	},
	"tabs": {
		"label": "Раздел «Персонажи»",
		"catalog": "Каталог",
		"sessions": "Мои разговоры"
	},
	"continue": {
		"title": "Продолжить",
		"seeAll": "Все разговоры"
	},
	"scenarioTiles": {
		"title": "Сценарии",
		"lead": "Готовые завязки разговора. Обновляются ежедневно."
	},
	"preview": {
		"start": "Начать разговор",
		"openHero": "Перейти в IEC Hero"
	},
	"start": {
		"title": "Начать разговор с {name}",
		"lead": "Формат и материалы относятся к этому разговору — на другие они не влияют.",
		"formatTitle": "Формат",
		"materialsTitle": "Материалы",
		"topicMaterials": "Разговор пойдёт по материалам открытой темы — их подставит StudyHub.",
		"outbound": {
			"title": "Что уйдёт в IEC Hero",
			"description": "Фрагменты ваших материалов и сообщений отправляются внешнему сервису — это необходимо для ответов на основе ваших источников. Если материалы не выбраны, фрагмент может быть взят из любого из них. Целые файлы, заметки и данные профиля никогда не передаются."
		},
		"existing": {
			"title": "Такой разговор уже есть",
			"continue": "Продолжить прошлый разговор"
		},
		"confirm": "Начать разговор",
		"confirmNew": "Начать новый",
		"cancel": "Отмена"
	},
	"sectionIntro": {
		"title": "Чем персонаж отличается от репетитора",
		"body": "Репетитор ведёт по программе, персонаж — свободный разговор в роли. Прохождение темы курса такие разговоры не засчитывают.",
		"bullets": [
			"Сценарии: подготовка к экзамену, разбор темы, диалог",
			"Разговоры живут в IEC Hero, у нас — только их список",
			"Список открывается офлайн, сам разговор требует сети"
		]
	}
}
